"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Checkbox-Widget.
 *
 * @class
 * @extends gc.gis.widget.GCItem
 * @memberof gc.gis.widget
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {boolean} options.active Initial checked?
 */
gc.gis.widget.GCToggleItem = function( options )
{
	this.active = options.active;

	gc.gis.widget.GCItem.call( this, options );
};
gc.gis.widget.GCToggleItem.prototype = Object.create( gc.gis.widget.GCItem.prototype );

/**
 * @inheritdoc
 */
gc.gis.widget.GCToggleItem.prototype.setActive = function( active )
{
	gc.gis.widget.GCItem.prototype.setActive.call( this, active );

	if( active )
	{
        this.element_control.prop('checked', true);	// do not use self.element_control.attr('checked', 'checked');
		this.element_label.addClass('active').addClass('gc-active');
	}
	else
	{
		this.element_control.removeAttr('checked');
		this.element_label.removeClass('active').removeClass('gc-active');
	}
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCToggleItem.prototype.setTooltip = function(tooltip)
{
	this.tooltip = tooltip;
	if (this.element_label)
	{
		this.element_label.attr('data-original-title', this.tooltip);
	}
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCToggleItem.prototype._render = function()
{
	var self = this;

	// input
	self.element_control = jQuery('<input>', {
		'class': 'gc-widget-control',
		type: 'checkbox',
		click: function( evt ) {
			try
			{
                // execute events
                if( self.action ) {
                    self.action.execute(self);
                }
                if( self.click ) {
                    self.click.call( this, evt );
                }

                // set/unset 'active' class
                if(self.element_control.is(':checked') ) {
                    self.element.addClass('active').addClass('gc-active');
                    self.element_label.addClass('active').addClass('gc-active');
                    self.active = true;
                }
                else {
                    self.element.removeClass('active').removeClass('gc-active');
                    self.element_label.removeClass('active').removeClass('gc-active');
                    self.active = false;
                }
			}
			catch( err )
			{
				gc.gis.iface.log.error( self, err );
			}

			jQuery(this).blur();
		}
	});

	// label
	if( this.label || this.icon || this.tooltip )
	{
		var element_label_text = jQuery('<span>', {
			'class': 'gc-widget-label-text',
			text: (self.label ? self.label : '')
		});

		self.element_label = jQuery('<label>', {
			title: self.tooltip ? self.tooltip : self.label,
			'class': 'gc-button gc-button-toggle gc-widget-label'
				+ (self.tooltip ? ' gc-widget-tooltip' : '')
				+ (self.badge ? ' gc-widget-badge' : '')
				+ (self.className ? ' '+ self.className : '')
		});

		if( self.icon ) {
			this.element_label.append( jQuery('<span>', {
				'class': 'gc-icon '+ self.icon
			}) );
		}

		self.element_label.prepend( self.element_control );
		if( self.label ) {
			self.element_label.append( element_label_text );
		}
		if(self.tooltip)
		{
			gc.gis.iface.ui.tooltip(self.element_label);
		}
		if( self.badge ) {
			self.element_label.append( self.badge.getElement() );
		}
	}
	else {
		self.element_label = self.element_control;
	}

	// Default state
	if( self.active ) {
        self.element_control.prop('checked', true);	// do not use self.element_control.attr('checked', 'checked');
		self.element_label.addClass('active').addClass('gc-active');
	}

	// Container
	var item = jQuery('<div>', {
		'class': 'gc-widget gc-widget-item'
			+ (self.active ? ' active gc-active' : '')
			+ (self.containerClassName ? ' '+ self.containerClassName : '')
	});
	if( this.element_label ) {
		item.append( this.element_label );
	}

	return item;
};

